import React, { useState, useEffect } from 'react'
import { Badge, Button, Card, Col, Row } from 'react-bootstrap'
import { Form, Table } from 'rsuite';
import LegacyPlusIcon from "@rsuite/icons/legacy/Plus";
import LegacyFileTextIcon from "@rsuite/icons/legacy/FileText";
import LegacyEdit2Icon from "@rsuite/icons/legacy/Edit2";
import LegacySendIcon from "@rsuite/icons/legacy/Send";
import LegacyTrashIcon from "@rsuite/icons/legacy/Trash";
import GenericBadge from '../../Shared/Badge/GenericBadge';
import RedStar from '../../Shared/GenericComponents/RedStar';
import YesNoRadioOption from '../../Shared/RadioButton/YesNoRadioOption';
import GenericPagination from '../Grid/GenericPagination';

function References(props) {
    const [hideReferencesGrid, setHideReferencesGrid] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [displayLength, setDisplayLength] = useState(20);
    const [page, setPage] = useState(1);

    const handleChangePage = (dataKey) => {
        setPage(dataKey);
    }
    const handleChangeLength = (dataKey) => {
        setPage(1);
        setDisplayLength(dataKey);
    }

    useEffect(() => {
        setHideReferencesGrid(props.hasReferences ?? true);
        setGridData(props.griddata)
        setHasLoaded(true);
    }, [props.griddata])

    const getData = () => {
        return gridData.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        })
    }
    const filteredData = getData();
    const handleMyNceesReferencesChange = (val) => {
        setHideReferencesGrid(val);
    }

    return (
        <div>

            <Card>
                <Card.Header>
                    <Row>
                        <Col>
                            <h6>References</h6>
                        </Col>
                        {
                            (!props.isReadOnly && hideReferencesGrid === false && !props.isInternal && (gridData.length > 0 || props.appType == "reinstatement")) &&
                            <Col> <Button style={{ float: 'right' }} onClick={props.openModal}>
                                <LegacyPlusIcon /> Add New</Button></Col>
                        }
                        {
                            props.isInternal && props.downloadPersonalReferences && hideReferencesGrid === false &&
                            <Col className="text-end"><Button onClick={props.downloadPersonalReferences}>Download PDF Version</Button></Col>
                        }
                    </Row>

                </Card.Header>
                <Card.Body>
                    <p>
                        <RedStar /> I have personal references listed in MyNCEES account.
                    </p>
                    <br />
                    <YesNoRadioOption isReadOnly={props.isReadOnly} radioName="hasReferences" handleChange={handleMyNceesReferencesChange} />
                    {(hideReferencesGrid === false && hasLoaded)
                        &&
                        <div>
                            {(props.appType == "reinstatement" || gridData.length > 0) ? <>
                                <Badge bg="danger" style={{ padding: '1rem' }}>You will be required to send each personal reference form for verification.</Badge>
                                <hr />
                                <Table wordWrap autoHeight data={filteredData}>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>Name</b>
                                        </Table.HeaderCell>
                                        <Table.Cell dataKey="name" />
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>Current Mailing Address</b>
                                        </Table.HeaderCell>
                                        <Table.Cell>{rowData => (rowData.address.streetAddress)}</Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>City/State</b>
                                        </Table.HeaderCell>
                                        <Table.Cell >{rowData => (`${rowData.address.city}, ${rowData.address.state?.code ?? rowData.address.provinceRegion}`)}</Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>Zip</b>
                                        </Table.HeaderCell>
                                        <Table.Cell>{rowData => (rowData.address.postalCode)}</Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>Email</b>
                                        </Table.HeaderCell>
                                        <Table.Cell dataKey="email" />
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            <b>Verification Status</b>
                                        </Table.HeaderCell>
                                        <Table.Cell>{rowData => (rowData.verificationStatus ? <GenericBadge status={rowData.verificationStatus.verificationStatus.toUpperCase()} /> : '')}</Table.Cell>
                                    </Table.Column>

                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                        </Table.HeaderCell>
                                        <Table.Cell dataKey="id">
                                            {rowData => {
                                                const verificationStatusId = rowData.verificationStatus?.id;
                                                function handleAction() {
                                                    if (!props.isReadOnly) {
                                                        var tempData = { ...rowData, modalType: 'Edit' }
                                                        props.openModal(tempData);
                                                    }
                                                }
                                                function openVerifierModal() {
                                                    props.openVerifierModal(rowData.id);
                                                }
                                                if (verificationStatusId > 1) {
                                                    if (verificationStatusId == 4 && props.isInternal) {
                                                        return (
                                                            <span>
                                                                <LegacyFileTextIcon
                                                                    title="View verifier response"
                                                                    onClick={openVerifierModal}
                                                                    style={{ cursor: "pointer" }}
                                                                    style={{
                                                                        fontSize: "2em"
                                                                    }} />&nbsp;&nbsp;
                                                                <LegacyEdit2Icon
                                                                    onClick={handleAction}
                                                                    style={{ cursor: "pointer" }}
                                                                    style={{
                                                                        fontSize: "2em"
                                                                    }} />
                                                            </span>
                                                        );
                                                        //    <span>
                                                        //        <Icon icon="send" size="2x" title="Send email for verification" onClick={() => { props.emailReference(rowData) }} style={{ cursor: "pointer" }} /> &nbsp;&nbsp;
                                                        //            <Icon icon="edit2" size="2x" title="Edit" onClick={handleAction} style={{ cursor: "pointer" }} />&nbsp;&nbsp;
                                                        //            <Icon icon="trash" size="2x" title="Delete" onClick={() => { props.deleteRow(rowData) }} style={{ cursor: "pointer" }} />
                                                        //    </span>
                                                        //);
                                                    }
                                                }
                                                else {
                                                    return (
                                                        <span>
                                                            <LegacySendIcon
                                                                title="Send email for verification"
                                                                onClick={() => { props.emailReference(rowData) }}
                                                                style={{ cursor: "pointer" }}
                                                                style={{
                                                                    fontSize: "2em"
                                                                }} /> &nbsp;&nbsp;
                                                            <LegacyEdit2Icon
                                                                onClick={handleAction}
                                                                style={{ cursor: "pointer" }}
                                                                style={{
                                                                    fontSize: "2em"
                                                                }} />&nbsp;&nbsp;
                                                            <LegacyTrashIcon
                                                                onClick={() => { props.deleteRow(rowData) }}
                                                                style={{ cursor: "pointer" }}
                                                                style={{
                                                                    fontSize: "2em"
                                                                }} />
                                                        </span>
                                                    );
                                                }
                                            }}
                                        </Table.Cell>
                                    </Table.Column>

                                </Table>
                                <GenericPagination
                                    setPage={setPage}
                                    page={page}
                                    displayLength={displayLength}
                                    setDisplayLength={setDisplayLength}
                                    dataLength={gridData.length}
                                    customOnChangePage={handleChangePage}
                                    customOnChangeLength={handleChangeLength}
                                />
                            </> :
                                <span className="badge badge-danger" style={{ padding: "0.5rem", textWrap: "wrap", textAlign: "left" }}>Personal references are not accepted from applicants. Please have personal references verified on your <b><a style={{ color: 'white' }} href="https://account.ncees.org/login" target="_blank">MyNCEES account</a></b> for application processing. If you have any questions, please contact LAPELS staff at <b><a style={{ color: 'white' }} href="mailto:applications@lapels.com">applications@lapels.com</a></b></span>
                            }
                        </div>}
                    <hr />
                    <p>
                        "I attest that the personal references listed in my application are in compliance with rule 1701.B."
                    </p>
                    <br />


                    <Form.Group>
                        <Row>
                            <Col sm={4}>
                                <Form.ControlLabel>
                                    <h5>Electronic Signature of Applicant:<RedStar /></h5>
                                    <span>(Type full name)</span>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={8}><Form.Control readOnly={props.isReadOnly} name="electronicSignature" /></Col>
                        </Row>
                        <Form.HelpText className="d-none">Electronic Signature of Applicant</Form.HelpText>
                    </Form.Group>
                </Card.Body>
            </Card>
        </div >
    );
}

export default References
